const prefix = '/';

const routeCodes = {
  chooseRestaurant: `${prefix}choose-restaurant`,
  home: prefix,
  userStatistic: `${prefix}user-statistics`,
  signIn: `${prefix}sign-in`,
  forgetPassword: `${prefix}forget-password`,
  newPassword: `${prefix}new-password/`,
  profile: `${prefix}profile`,
  ipratico: `${prefix}ipratico`,
  profileEdit: `${prefix}profile/account/:id`,
  restaurant: `${prefix}profile/restaurant`,
  restaurantCreate: `${prefix}profile/restaurant/create`,
  restaurantView: `${prefix}profile/restaurant/:id`,
  firm: `${prefix}profile/firm`,
  firmCreate: `${prefix}profile/firm/create`,
  firmView: `${prefix}profile/firm/:id`,
  reminder: `${prefix}reminder`,
  reservations: `${prefix}reservations`,

  menu: `${prefix}menu`,
  menuDishes: `${prefix}menu/dishes`,
  menuDishesCreate: `${prefix}menu/dishes/create`,
  menuDishesEdit: `${prefix}menu/dishes/:id`,
  menuCategories: `${prefix}menu/categories`,
  menuCategoriesCreate: `${prefix}menu/categories/create`,
  menuCategoriesEdit: `${prefix}menu/categories/:id`,
  menuOptions: `${prefix}menu/options`,
  menuOptionsEdit: `${prefix}menu/options/:id`,
  menuOptionsCreate: `${prefix}menu/options/create`,
  menuVariantsEdit: `${prefix}menu/variants/:id`,

  settings: `${prefix}settings`,
  settingsIpratico: `${prefix}settings/ipratico`,
  settingsConfigsDelivery: `${prefix}settings/delivery`,
  settingsConfigsServicesCreate: `${prefix}settings/services/create`,
  settingsConfigsServicesView: `${prefix}settings/services/:id`,

  specialMenu: `${prefix}menu/special-menu`,
  specialMenuCreate: `${prefix}menu/special-menu/create`,
  specialMenuEdit: `${prefix}menu/special-menu/:id`,

  statistics: `${prefix}statistics`,

  team: `${prefix}team`,
  teamShow: `${prefix}team/:id`,
  teamCreate: `${prefix}team/create`,

  finances: `${prefix}finances`,

  help: `${prefix}help`,
  helpMessages: `${prefix}help/:id`,

  register: `${prefix}register`,

  companies: `${prefix}companies`,
  restaurants: `${prefix}restaurants`,
  bonuses: `${prefix}bonuses`,
  bonusesRestaurants: `${prefix}pay-bonuses-restaurants`,
  bonusesInvite: `${prefix}bonuses/invite`,
  bonusesInviteEdit: `${prefix}bonuses/invite/:id`,
  bonusesEveryBooking: `${prefix}bonuses/every-booking`,
  bonusesEveryBookingEdit: `${prefix}bonuses/every-booking/:id`,
  bonusFromOwnersToUser: `${prefix}bonuses/from-owners-to-users`,
  bonusFromOwnersToUserEdit: `${prefix}bonuses/from-owners-to-users/:id`,
  bonusSuperBonus: `${prefix}bonuses/super-bonus`,
  bonusSuperBonusEdit: `${prefix}bonuses/super-bonus/:id`,
  bonusDiscoverRestaurant: `${prefix}bonuses/discover-restaurant`,
  bonusDiscoverRestaurantEdit: `${prefix}bonuses/discover-restaurant/:id`,
  bonusManual: `${prefix}bonuses/manual`,
  bonusManualEdit: `${prefix}bonuses/manual/:id`,
  restaurantsView: `${prefix}restaurants/:restaurantId`,
  superAdmin: {
    // TODO administration
    restaurantHome: `${prefix}restaurants/:restaurantId/home`,

    profile: `${prefix}restaurants/:restaurantId/profile`,
    ipratico: `${prefix}restaurants/:restaurantId/ipratico`,
    notifications: `${prefix}notifications`,
    notificationsTickets: `${prefix}notifications/tickets/:id`,

    administration: `${prefix}administration`,
    administrationOwners: `${prefix}administration/owners`,
    administrationOwnersCreate: `${prefix}administration/owners/create`,
    administrationOwnersEdit: `${prefix}administration/owners/:id`,

    administrationCompany: `${prefix}administration/company`,
    administrationCompanyCreate: `${prefix}administration/company/create`,
    administrationCompanyEdit: `${prefix}administration/company/:id`,

    administrationRestaurant: `${prefix}administration/restaurant`,
    administrationRestaurantCreate: `${prefix}administration/restaurant/create`,
    administrationRestaurantEdit: `${prefix}administration/restaurant/:id`,

    // Menu start
    menu: `${prefix}restaurants/:restaurantId/menu`,
    menuDishes: `${prefix}restaurants/:restaurantId/menu/dishes`,
    menuDishesCreate: `${prefix}restaurants/:restaurantId/menu/dishes/create`,
    menuDishesEdit: `${prefix}restaurants/:restaurantId/menu/dishes/:id`,
    menuCategories: `${prefix}restaurants/:restaurantId/menu/categories`,
    menuCategoriesCreate: `${prefix}restaurants/:restaurantId/menu/categories/create`,
    menuCategoriesEdit: `${prefix}restaurants/:restaurantId/menu/categories/:id`,
    menuOptions: `${prefix}restaurants/:restaurantId/menu/options`,
    menuOptionsEdit: `${prefix}restaurants/:restaurantId/menu/options/:id`,
    menuOptionsCreate: `${prefix}restaurants/:restaurantId/menu/options/create`,
    menuVariantsEdit: `${prefix}restaurants/:restaurantId/menu/variants/:id`,
    // Menu end

    // settings start
    settings: `${prefix}restaurants/:restaurantId/settings`,
    settingsIpratico: `${prefix}restaurants/:restaurantId/settings/ipratico`,
    settingsConfigsDelivery: `${prefix}restaurants/:restaurantId/settings/delivery`,
    settingsConfigsServicesCreate: `${prefix}restaurants/:restaurantId/settings/services/create`,
    settingsConfigsServicesView: `${prefix}restaurants/:restaurantId/settings/services/:id`,
    // settings end

    // special menu start
    specialMenu: `${prefix}restaurants/:restaurantId/menu/special-menu`,
    specialMenuCreate: `${prefix}restaurants/:restaurantId/menu/special-menu/create`,
    specialMenuEdit: `${prefix}restaurants/:restaurantId/menu/special-menu/:id`,
    // special menu end

    // offers start
    offers: `${prefix}restaurants/:restaurantId/offers`,
    offersCreatCalendar: `${prefix}restaurants/:restaurantId/offers/bonus-calendar`,
    offersCreatPayment: `${prefix}restaurants/:restaurantId/offers/bonus-payment`,
    offersCreatBonusAmount: `${prefix}restaurants/:restaurantId/offers/bonus-amount`,
    offersCreatBonusReservation: `${prefix}restaurants/:restaurantId/offers/bonus-reservation`,
    // offers end

    // stripe start
    stripeRefresh: `${prefix}restaurants/:restaurantId/stripe/refresh`,
    stripeSuccess: `${prefix}restaurants/:restaurantId/stripe/success`,
    // stripe end

    // qr start
    generateQR: `${prefix}restaurants/:restaurantId/qr`,
    // qr end

    // help start
    help: `${prefix}restaurants/:restaurantId/help`,
    // help end

    // finances start
    finances: `${prefix}restaurants/:restaurantId/finances`,
    // finances end

    // statistics start
    statistics: `${prefix}restaurants/:restaurantId/statistics`,
    // statistics end

    // team start
    team: `${prefix}restaurants/:restaurantId/team`,
    teamShow: `${prefix}restaurants/:restaurantId/team/:id`,
    teamCreate: `${prefix}restaurants/:restaurantId/team/create`,
    // team end

    qr: `${prefix}restaurants/:restaurantId/qr`,
  },

  offers: `${prefix}offers`,
  allBonuses: `${prefix}all-bonuses`,
  offersCreatCalendar: `${prefix}offers/bonus-calendar`,
  offersCreatPayment: `${prefix}offers/bonus-payment`,
  offersCreatBonusAmount: `${prefix}offers/bonus-amount`,
  offersCreatBonusReservation: `${prefix}offers/bonus-reservation`,

  stripeRefresh: `${prefix}stripe/refresh`,
  stripeSuccess: `${prefix}stripe/success`,
  generateQR: `${prefix}qr`,
  // TODO replace all routes with object, example:
  // settings: {
  //   path: `${prefix}settings`,
  //   key: 'setting',
  // }
};

export default routeCodes;
